<script>
import { capitalize } from "@/utils/capitalize";

export default {
  name: "ConfirmUpgradeModal",
  props: {
    newPlan: {
      type: String,
      required: true,
    },
    proceedWithUpgrade: {
      type: Function,
      required: true,
    },
    newPlanPrice: {
      type: String,
      required: true,
    },
    isYearly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    newPlanDisplayName() {
      return capitalize(this.newPlan);
    },
    modalTitle() {
      return this.$t("account.subscription.confirmUpgrade");
    },
  },
  methods: {
    upgrade() {
      this.proceedWithUpgrade(this.newPlan, this.isYearly);
      this.$egModal.hide("confirm_upgrade_modal");
    },
  },
};
</script>

<template>
  <eg-modal
    id="confirm_upgrade_modal"
    :title="modalTitle"
    size="lg"
    centered
    no-stacking
    @close="$emit('closed')"
  >
    <p>
      {{
        $t("account.subscription.confirmUpgradeDescription", {
          plan: newPlanDisplayName,
          interval: isYearly
            ? $t("account.subscription.yearly")
            : $t("account.subscription.monthly"),
          price: newPlanPrice,
        })
      }}
    </p>

    <template #footer="{ close }">
      <div class="d-flex justify-content-end">
        <eg-b-button variant="outline-info" @click="close">
          {{ $t("common.cancel") }}
        </eg-b-button>
        <eg-b-button class="ml-3" variant="info" @click="upgrade">
          {{ $t("account.subscription.upgrade") }}
        </eg-b-button>
      </div>
    </template>
  </eg-modal>
</template>
